import { Platform } from 'react-native';

/**
 * "Finished editing" for a TextInput on every platform. React Native Web's
 * TextInput never fires onEndEditing, so inputs that saved there did nothing
 * on web; blur is the web equivalent. Native keeps onEndEditing so each edit
 * saves once.
 */
export function finishEditingProps(handler: () => void): {
  onBlur?: () => void;
  onEndEditing?: () => void;
} {
  return Platform.OS === 'web' ? { onBlur: handler } : { onEndEditing: handler };
}
